import { t } from '@gem/modules/i18n';

import Tasks from 'APP/Tasks';
import { BackgroundCall } from 'STORE/BackgroundCalls/BackgroundCall/BackgroundCall';

interface IShowConfirmRunCallData {
  call: BackgroundCall;
  groupId: string;
}

export const showConfirmRunCall = async ({
  call,
  groupId,
}: IShowConfirmRunCallData): Promise<void> => {
  const res = await Tasks.app.showConfirm({
    text: t('calls_active_call_alert'),
    primaryText: t('common_yes'),
    secondaryText: t('common_no'),
  });

  if (res && call.channelId) {
    Tasks.calls.joinToCall({
      groupId: groupId,
      channelId: call.channelId,
      withAudio: false,
      withVideo: false,
      providerType: call.callProvider,
    });
  }
};
